import { useMasterDataContext } from "../shared/context/MasterDataContext";

export interface MasterDataHookReturn {
  masterData: MasterDataItem[];
  capabilitiesData: String[];
  filterMapData: any;
  projectsFilterData: any;
  isLoading: boolean;
  error: string | null;
  refetch: () => Promise<void>;
  clearError: () => void;
  clearMasterData: () => void;
};

export interface capabilitiesDataHookReturn {
  capabilitiesData: String[];
  isLoading: boolean;
  error: string | null;
  refetch: () => Promise<void>;
  clearError: () => void;
};

export interface MetaDataType {
  alias_name: string;
  label: string;
  domain: string;
};

export interface MasterDataItem {
  domain: string;
  key: string;
  value: string;
  display_text: string;
  helper_text: string;
  properties: string;
  display_order: number;
  created_by: string;
  created_date: string | null;
  updated_by: string;
  updated_date: string | null;
  is_dropdown: boolean;
};

export const useDisplayField = (metaData: MetaDataType | null | any) => {

  const { getDisplayText, getLabel, getDomain, getByDomain, getFilterOptions } = useMasterDataContext();

  const getMasterDataLabel = (value: string | string[], key: string) => {
    let values: any = [];
    let domain = getDomain(key, metaData);
    if (Array.isArray(value)) {
      value.map((item) => {
        values.push(getDisplayText(item, getDomain(key, metaData)) || value);
      });
      return values.join(', ');
    }
    return domain ? getDisplayText(value, domain) : value;
  };

  const getMetaDataLabel = (key: string) => {
    return getLabel(key, metaData);
  };

  const getOptions = (key: string) => {
    const response = getDomain(key, metaData);
    if (response) {
      return getByDomain(response).filter((value: { is_dropdown: boolean }) => {
        return value.is_dropdown;
      }).sort((a, b) => {
        return a.display_order - b.display_order;
      });
    } else {
      return [];
    }
  };

  return {
    getDomain,
    getMasterDataLabel,
    getMetaDataLabel,
    getOptions,
    getByDomain,
    getFilterOptions
  };
};
